import React, { useEffect, useRef } from 'react';
import s from './BestOfferCard.module.scss';
import { Typography } from 'ui-v2/components/Typography';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { trackProductViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Button } from 'ui-v2/components/Button';
const BestOfferCard = ({ card, id, index }) => {
  const rootRef = useRef<HTMLDivElement>();
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const productRef = useRef(false);

  useEffect(() => {
    if (inViewPort && !productRef.current) {
      trackProductViewedStoreV2(encodeURI(card?.title), card?.parentId, {
        description: card?.eventType,
      });
      productRef.current = true;
    }
  }, [card, inViewPort]);
  return (
    <div
      className={s.card}
      ref={rootRef}
      id={id}
      key={card?.parentId}
      data-index={index}
    >
      <div className={s.content}>
        <div className={s.image}>
          <AnimatedImage src={card.coverImage} alt={card.title} />
        </div>
        <div className={s.textStack}>
          <Typography label={card.title} variant="label_2_semi_bold" />
          <Typography
            label={card.subtitle1}
            variant="label_4_regular"
            color="secondary"
          />
        </div>
        <div className={s.button}>
          <Button label="Shop Now" variant="link_color" size="small" />
        </div>
      </div>
      <div className={s.bottomColor}>
        <div className={s.circle}></div>
      </div>
    </div>
  );
};

export default BestOfferCard;
